import { render, staticRenderFns } from "./JobMatchingEditor.vue?vue&type=template&id=c6ce0142&scoped=true&"
import script from "./JobMatchingEditor.vue?vue&type=script&lang=ts&"
export * from "./JobMatchingEditor.vue?vue&type=script&lang=ts&"
import style0 from "./JobMatchingEditor.vue?vue&type=style&index=0&id=c6ce0142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce0142",
  null
  
)

export default component.exports